import { ComponentChildren } from 'preact';
import { useEffect, useCallback } from 'preact/hooks';
import { useToggle } from '../UNSAFE_useToggle';

export type UseClearIconProps = {
  clearIcon?: ComponentChildren;
  display?: 'always' | 'conditionally' | 'never';
  hasValue?: boolean;
  isEnabled?: boolean;
  isFocused?: boolean;
  isHover?: boolean;
};

/**
 * A custom hook that handles showing/hiding clear icon
 */
export function useClearIcon({
  clearIcon,
  display,
  hasValue,
  isEnabled = true,
  isFocused = false,
  isHover = false
}: UseClearIconProps) {
  const shouldRenderClearIcon = useCallback(
    () =>
      isEnabled &&
      (display === 'always' || (display === 'conditionally' && hasValue && (isFocused || isHover))),
    [display, hasValue, isEnabled, isFocused, isHover]
  );
  const { bool, setFalse, setTrue } = useToggle(shouldRenderClearIcon());

  useEffect(() => {
    shouldRenderClearIcon() ? setTrue() : setFalse();
  }, [shouldRenderClearIcon, setTrue, setFalse]);

  return bool ? clearIcon : null;
}
